var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "left-box" }, [
    _c("div", { staticClass: "im-left-nav", attrs: { id: "im-left-nav" } }, [
      _c(
        "div",
        { staticClass: "functional_module" },
        _vm._l(_vm.functionalArr, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "m-l-5 t-a-center f-s-12",
              class: { active: item.apiKey == _vm.selectedTab },
              on: {
                click: function ($event) {
                  return _vm.activeTab(item)
                },
                dblclick: function ($event) {
                  return _vm.doubleClick(item)
                },
              },
            },
            [
              _c("div", { staticClass: "icon" }, [
                item.apiKey == _vm.selectedTab
                  ? _c("img", { attrs: { src: item.activeIcon } })
                  : _c("img", { attrs: { src: item.unActiveIcon } }),
              ]),
              _c("div", { staticClass: "text m-t-2" }, [
                _vm._v(" " + _vm._s(item.text) + " "),
              ]),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.unreadCountCp.count != 0 &&
                        item.apiKey == "message",
                      expression:
                        "unreadCountCp.count!=0 && item.apiKey == 'message'",
                    },
                  ],
                  staticClass: "unread-count-cp",
                },
                [_vm._v(_vm._s(_vm.unreadCountCp.count))]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.unreadCountCp.mute && item.apiKey == "message",
                      expression:
                        "unreadCountCp.mute && item.apiKey == 'message'",
                    },
                  ],
                  staticClass: "unread-count-cp-mute",
                  staticStyle: {
                    top: "0px",
                    right: "6px",
                    "background-color": "#EC5943",
                  },
                },
                [_vm._v(" ")]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.notificationList.total > 0 &&
                        item.apiKey == "notification" &&
                        _vm.showNotificationFlag !== "false",
                      expression:
                        "notificationList.total > 0 && item.apiKey == 'notification' && showNotificationFlag !== 'false'",
                    },
                  ],
                  staticClass: "unread-count-cp-mute",
                  staticStyle: {
                    top: "0px",
                    right: "6px",
                    "background-color": "#EC5943",
                  },
                },
                [_vm._v(" ")]
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }